import React from "react";

import Checkbox from "../../../../../lib/Checkbox/Checkbox";

const SelectInputOption = ({ checked, option, onClick, disabled }) => (
  <Checkbox
    checked={checked}
    label={option.label}
    onClick={event => {
      if (disabled) {
        return;
      }

      onClick(event);
    }}
    className="lp_select-input_option py-0"
  />
);

export default SelectInputOption;
